import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../../services/AuthService'; 

const authService = new AuthService();

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = authService.isAuthenticated(); 

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
}

export default ProtectedRoute;